import axios from "axios";

const getUnassignProgress = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/serialnumber/api/v1/serialnumber/unassign/${id}/progress`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getUnassignProgress;
